import {AddPaymentMethod} from "Components/Buttons/AddPaymentButton";
import {BankCard} from "Components/Cards/BankCard";
import {UserLayout} from "Layouts/User/Layout";
import {UserSectionContainer} from "Components/PageSections/User/UserSectionContainer";
import {UserSectionHeader} from "Components/PageSections/User/UserSectionHeader";
import {ReactSVG} from "react-svg";
import {BasicBreadcrumbs} from "Components/Breadcrumbs/Breadcrumbs";
import {useUserBankCardsQuery} from "Hooks/Queries/User/useUserBankCardsQuery";
import {ToastContainer, toast} from "react-toastify";
import {handleAddCardRequest} from "Functions/Checkout/handleAddCardRequest";
import {useBankCardCheckQuery} from "Hooks/Queries/User/useBankCardCheckQuery";
import {useCustomQuery} from "Hooks/useQuery";
import {useEffect, useState} from "react";
import {SavedCardPayment} from "Components/Modals/Payments/SaveCard";
import {ErrorPayment} from "Components/Modals/Payments/ErrorPayment";
import {BANKS} from "../../../Components/PageSections/Checkout/BankCards";
import {FormControlLabel, Switch, SwitchProps} from "@mui/material";
import {styled} from "@mui/material/styles";
import ChoseBank from "./ChoseBank";
import {bool} from "yup";


const IOSSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({theme}) => ({
  width: 42,
  height: 26,
  margin: "0 !important",
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#23AD61',
        opacity: 1,
        border: 0,
        ...theme.applyStyles('dark', {
          backgroundColor: '#2ECA45',
        }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
      ...theme.applyStyles('dark', {
        color: theme.palette.grey[600],
      }),
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      ...theme.applyStyles('dark', {
        opacity: 0.3,
      }),
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    ...theme.applyStyles('dark', {
      backgroundColor: '#39393D',
    }),
  },
}));

const StyledFormControlLabel = styled(FormControlLabel)(({theme}) => ({
  '.MuiFormControlLabel-label': {
    color: '#070A1499',
    marginRight: 6,// <-- Set your desired label color here
    fontWeight: 500,
    ...theme.applyStyles('dark', {
      color: '#070A1499', // Example color in dark mode
      fontSize: 16
    }),
  },
}));

export const BankCards = () => {
  const {bankCard, isLoadingBankCard, isErrorBankCard, isSuccessBankCard} =
      useUserBankCardsQuery();
  const query = useCustomQuery();

  const [chosenBank, setChosenBank] = useState<string | null>(null);
  const [isChecked, setIsChecked] = useState<boolean>(true);

  const {bankCardCheck, isLoadingBankCardCheck, isSuccessBankCardCheck} =
      useBankCardCheckQuery(query.get("orderId"));
  const [isOpenSuccess, setIsOpenSuccess] = useState(false);
  const [isOpenErrorMessage, setIsOpenErrorMessage] = useState(false);

  useEffect(() => {
    if (query.get("orderId")) {
      if (isLoadingBankCardCheck == false && isSuccessBankCardCheck) {
        if (
            JSON.parse(
                JSON.parse(JSON.stringify(localStorage.getItem("bankCardOrderId")))
            ) != query.get("orderId")
        ) {
          if (bankCardCheck?.status == "SUCCESS") {
            setIsOpenSuccess(true);
            localStorage.setItem(
                "bankCardOrderId",
                JSON.stringify(query.get("orderId"))
            );
          } else if (bankCardCheck?.status == "PAYMENT_FAILED") {
            setIsOpenErrorMessage(true);
            localStorage.setItem(
                "orderId",
                JSON.stringify(query.get("bankCardOrderId"))
            );
          }
        }
      }
    }
  }, [isSuccessBankCardCheck, isLoadingBankCardCheck]);


  return (
      <>
        <ToastContainer/>
        <UserLayout>
          <SavedCardPayment
              open={isOpenSuccess}
              close={() => setIsOpenSuccess(false)}
          />
          <ErrorPayment
              open={isOpenErrorMessage}
              close={() => setIsOpenErrorMessage(true)}
          />
          <BasicBreadcrumbs
              breadcrumbs={[
                {
                  title: "საბანკო ბარათები",
                  link: "user/bankcards",
                },
              ]}
          />
          <UserSectionHeader title="ჩემი ბართები"/>
          <UserSectionContainer>

            {bankCard?.savedCards.length > 0 &&
                <h2 className="font-bold text-base text-blackPrimary-100 leading-[24px] mb-4">
                  დამახსოვრებული ბარათები
                </h2>}

            <div className="grid grid-cols-2 md:grid-cols-1 gap-[30px]">
              {bankCard?.savedCards?.map((card: any, index: any) => (
                  <BankCard card={card} key={index}/>
              ))}

              {/*<AddPaymentMethod*/}
              {/*    onClick={() => handleAddCardRequest(toast, false, undefined)}*/}
              {/*    title="დაამატე გადახდის მეთოდი"*/}
              {/*    icon={<ReactSVG src="/images/icons/bankcard.svg"/>}*/}
              {/*/>*/}
            </div>

            {/*<h2 className="font-bold mt-10 text-base text-blackPrimary-100 leading-[24px] mb-4">*/}
            {/*  სარეზერვო ბარათები*/}
            {/*</h2>*/}

            {/*<span className="font-medium text-sm text-secondaryGray-100">*/}
            {/* როდესაც გადახდის ძირითადი მეთოდით ვერ ხერხდება თანხის ჩამოჭრა, თანხა ჩამოიჭრება სარეზერვო ბარათიდან*/}
            {/*</span>*/}

            <div className={"flex items-center justify-between mt-8 pr-3"}>
              <span className={"font-bold text-base text-blackPrimary-100"}>ახალი ბარათის დამატება</span>
              <div>
                <StyledFormControlLabel
                    control={<IOSSwitch sx={{m: 1}} defaultChecked/>}
                    checked={isChecked}
                    onChange={(event, checked) => setIsChecked(checked)}
                    labelPlacement={"start"}
                    label="ბარათის დამახსოვრება"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-1 md:gap-4 gap-[30px] mt-3">
              {BANKS?.map((bank) => {
                return <ChoseBank bank={bank} key={bank.id} isChecked={isChecked}/>
              })}
            </div>
          </UserSectionContainer>
        </UserLayout>
      </>
  );
};
